import React, { useState, useEffect } from 'react';
import { Card, Descriptions, Button, Modal, Form, Input, message, Tag, Typography, Space } from 'antd';
import { UserOutlined, EditOutlined, BankOutlined, PhoneOutlined, MailOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

const PersonalCenter = () => {
  const [userInfo, setUserInfo] = useState({});
  const [isUsernameModalOpen, setIsUsernameModalOpen] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => {
    // 从 localStorage 获取用户信息
    const storedInfo = localStorage.getItem('user_info');
    if (storedInfo) {
      const parsed = JSON.parse(storedInfo);
      setUserInfo({
        account: parsed.user_name || 'admin',
        username: parsed.nick_name || '管理员',
        roles: ['账务','项目经理'],
        phone: parsed.phone || '13800138000',
        email: parsed.email || 'admin@example.com',
        enterprise: '鹤梦科技 (深圳) 有限公司',
        enterpriseId: 'HM-8827-X'
      });
    }
  }, []);

  const handleEditUsername = () => {
    form.setFieldsValue({
      username: userInfo.username
    });
    setIsUsernameModalOpen(true);
  };

  const handleSaveUsername = async () => {
    try {
      const values = await form.validateFields();
      const newUserInfo = { ...userInfo, username: values.username };
      setUserInfo(newUserInfo);
      
      // 同步更新 localStorage
      const stored = JSON.parse(localStorage.getItem('user_info') || '{}');
      localStorage.setItem('user_info', JSON.stringify({
        ...stored,
        nick_name: values.username
      }));

      message.success('用户名更新成功');
      setIsUsernameModalOpen(false);
    } catch (error) {
      console.log('Validate Failed:', error);
    }
  };

  return (
    <div style={{ padding: '24px' }}>
      <div style={{ marginBottom: 16 }}>
        <Title level={4}>个人中心</Title>
      </div>
      <Space direction="vertical" size="large" style={{ width: '100%' }}>
        <Card 
          title={<Space><UserOutlined /><span>个人信息</span></Space>}
          bordered={false}
        >
          <Descriptions column={2} bordered>
            <Descriptions.Item label="登录账号">{userInfo.account}</Descriptions.Item>
            <Descriptions.Item label="用户名">
              <Space>
                <Text>{userInfo.username}</Text>
                <Button 
                  type="link" 
                  size="small" 
                  icon={<EditOutlined />} 
                  onClick={handleEditUsername}
                  style={{ padding: 0 }}
                >
                  修改
                </Button>
              </Space>
            </Descriptions.Item>
            <Descriptions.Item label="角色" span={2}>
              <Space size={[2, 8]} wrap>
                {userInfo.roles?.map(role => <Tag color="blue" key={role}>{role}</Tag>)}
              </Space>
            </Descriptions.Item>
            <Descriptions.Item label={<Space><PhoneOutlined />手机号</Space>}>{userInfo.phone}</Descriptions.Item>
            <Descriptions.Item label={<Space><MailOutlined />邮箱</Space>}>{userInfo.email}</Descriptions.Item>
          </Descriptions>
        </Card>

        <Card 
          title={<Space><BankOutlined /><span>企业信息</span></Space>}
          bordered={false}
        >
          <Descriptions column={2} bordered>
            <Descriptions.Item label="所属企业">{userInfo.enterprise}</Descriptions.Item>
            <Descriptions.Item label="企业ID">{userInfo.enterpriseId}</Descriptions.Item>
          </Descriptions>
        </Card>
      </Space>

      <Modal
        title="修改用户名"
        open={isUsernameModalOpen}
        onOk={handleSaveUsername}
        onCancel={() => setIsUsernameModalOpen(false)}
        destroyOnClose
        okText="保存"
        cancelText="取消"
        width={400}
      >
        <Form form={form} layout="vertical" style={{ marginTop: 16 }}>
          <Form.Item
            name="username"
            label="用户名"
            rules={[{ required: true, message: '请输入用户名' }]}
          >
            <Input placeholder="请输入新的用户名" />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default PersonalCenter;
